export default "__VITE_ASSET__BMcAXNt2__"